import { Box, Card, CardContent, Divider } from '@mui/material';
import Header from '@/component/Header';
import ManualRewardForm from '@/component/stake-db/reward/ManualRewardForm';

export default function StakeDbManualReward() {
  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title="Stake-db 수동 리워드 등록" />
        <Divider />
        <CardContent
          sx={{
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <ManualRewardForm />
        </CardContent>
      </Card>
    </Box>
  );
}
